/**
 * @generated SignedSource<<edb0da2c2a0e2d84142ffc0587abcec0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceContainerPrimary_viewer$data = {
  readonly buyerUrgencyInfo?: {
    readonly itemUrgency: {
      readonly hasUrgencyInfo: boolean | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedUrgencyLazy_buyerUrgencyInfo">;
  } | null;
  readonly itemRead: ReadonlyArray<{
    readonly displayInfo?: {
      readonly ctas: {
        readonly showAcceptOffer: boolean | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceStickyHeader_displayInfo" | "PdpRespSidebarBlurbs_displayInfo" | "PdpRespSidebarButtons_displayInfo" | "PdpSharedPromoCode_displayInfo">;
    } | null;
    readonly displayPrice?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"IncludedLabels_displayPrice" | "PriceDisplayVariant_displayPrice" | "useShowIncludedLabelsInline_displayPrice">;
    } | null> | null;
    readonly itemIsOnHold?: boolean | null;
    readonly seller?: {
      readonly isAccessible: boolean | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_seller">;
    } | null;
    readonly skus?: ReadonlyArray<{
      readonly displayPrice?: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"IncludedLabels_displayPrice" | "PriceDisplayVariant_displayPrice" | "useShowIncludedLabelsInline_displayPrice">;
      } | null> | null;
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceStickyHeader_sku" | "PdpRespSidebarBlurbs_sku">;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"EstimatedValue_item" | "IncludedLabels_item" | "PdpRespDetailTabs_item" | "PdpRespIconBubblesWrapper_item" | "PdpRespMarketplaceNotifications_item" | "PdpRespMarketplaceStickyHeader_item" | "PdpRespSharedBreadcrumbs_item" | "PdpRespSharedHeroCarousel_item" | "PdpRespSharedPrintDetails_item" | "PdpRespSharedTitle_item" | "PdpRespSidebarBlurbs_item" | "PdpRespSidebarButtons_item" | "PdpRespSidebarDetails_item" | "PdpRespSidebarSellerInfoAndContactLazy_item" | "PdpRespSimilarItemsLanding_item" | "PdpRespSwatchSelector_item" | "PdpSharedDesignYourOwnPillLazy_item" | "PdpSharedEstimateSimilarSoldRange_item" | "PdpSharedItemFavorites_item" | "PdpSharedPriceDisplay_item" | "PdpSharedQuantitySelect_item" | "PriceDisplayVariant_item" | "PricingGuidanceInfo_item" | "usePdpEstimateSimilarSoldTest_item" | "usePdpEstimateSimilarSold_item" | "usePdpPricingAndSaleVariant_item" | "useShowIncludedLabelsInline_item">;
  } | null> | null;
  readonly similarLandingItems: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsLanding_similarItems">;
  } | null;
  readonly sponsoredItems?: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsLanding_sponsoredItems">;
  } | null;
  readonly user?: {
    readonly hasMerchandizingPermission: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailTabs_user" | "PdpRespIconBubblesWrapper_user" | "PdpRespMarketplaceNotifications_user" | "PdpRespMarketplaceStickyHeader_user" | "PdpRespSharedHeroCarousel_user" | "PdpRespSharedPrintDetails_user" | "PdpRespSidebarBlurbs_user" | "PdpRespSidebarButtons_user" | "PdpRespSidebarDetails_user" | "PdpRespSidebarSellerInfoAndContactLazy_user" | "PdpRespSimilarItemsLanding_user" | "PdpRespSwatchSelector_user" | "PdpSharedItemFavorites_user" | "PdpSharedPromoCode_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerChatLoader_viewer" | "PdpRespDetailTabs_viewer" | "PdpRespIconBubblesWrapper_viewer" | "PdpRespSharedHeroCarousel_viewer" | "PdpRespSidebarDetails_viewer" | "PdpSharedPageTracker_viewer" | "PdpSharedPromoCode_viewer" | "PdpSharedRestrictedMaterials_refactor_viewer" | "usePdpEstimateSimilarSold_viewer">;
  readonly " $fragmentType": "PdpRespMarketplaceContainerPrimary_viewer";
};
export type PdpRespMarketplaceContainerPrimary_viewer$key = {
  readonly " $data"?: PdpRespMarketplaceContainerPrimary_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceContainerPrimary_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v1 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v2 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v3 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v4 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v5 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v6 = {
  "alias": null,
  "args": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PriceDisplayVariant_displayPrice"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IncludedLabels_displayPrice"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowIncludedLabelsInline_displayPrice"
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "afterDisplayOrBuaSsr"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "guestId"
    },
    {
      "kind": "RootArgument",
      "name": "isEstimateSimilarSoldVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "isPDPDesktopAggregationVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds"
    },
    {
      "kind": "RootArgument",
      "name": "mlType"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "similarItemsCount"
    },
    {
      "kind": "RootArgument",
      "name": "skipSponsoredItems"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplaceContainerPrimary_viewer",
  "selections": [
    {
      "condition": "isPDPDesktopAggregationVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespDetailTabs_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_viewer"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedPageTracker_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespDealerChatLoader_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedRestrictedMaterials_refactor_viewer"
        },
        {
          "alias": null,
          "args": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "concreteType": "BuyerUrgencyInfo",
          "kind": "LinkedField",
          "name": "buyerUrgencyInfo",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedUrgencyLazy_buyerUrgencyInfo"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemUrgencyInfoType",
              "kind": "LinkedField",
              "name": "itemUrgency",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasUrgencyInfo",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "isPDPDesktopAggregationVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarDetails_viewer"
        }
      ]
    },
    {
      "condition": "isEstimateSimilarSoldVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "usePdpEstimateSimilarSold_viewer"
            }
          ]
        }
      ]
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "itemRead",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "itemIsOnHold",
              "args": [
                (v2/*: any*/)
              ],
              "kind": "ScalarField",
              "name": "isOnHold",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Seller",
              "kind": "LinkedField",
              "name": "seller",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isAccessible",
                  "storageKey": null
                },
                {
                  "condition": "afterDisplay",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespSidebarSellerInfoAndContactLazy_seller"
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                (v2/*: any*/),
                {
                  "kind": "Literal",
                  "name": "page",
                  "value": "pdp"
                }
              ],
              "concreteType": "ItemDisplayInfo",
              "kind": "LinkedField",
              "name": "displayInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CTADisplay",
                  "kind": "LinkedField",
                  "name": "ctas",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showAcceptOffer",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpSharedPromoCode_displayInfo"
                },
                {
                  "condition": "afterDisplay",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespSidebarBlurbs_displayInfo"
                    }
                  ]
                },
                {
                  "condition": "afterDisplayOrBuaSsr",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespSidebarButtons_displayInfo"
                    }
                  ]
                },
                {
                  "condition": "isPDPDesktopAggregationVariant",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespMarketplaceStickyHeader_displayInfo"
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemSkuType",
              "kind": "LinkedField",
              "name": "skus",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "condition": "afterDisplay",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespSidebarBlurbs_sku"
                    }
                  ]
                },
                {
                  "condition": "isPDPDesktopAggregationVariant",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespMarketplaceStickyHeader_sku"
                    }
                  ]
                },
                {
                  "condition": "isMultiSku",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    (v6/*: any*/)
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "condition": "afterDisplayOrBuaSsr",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpSharedPriceDisplay_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PriceDisplayVariant_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "IncludedLabels_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "useShowIncludedLabelsInline_item"
                },
                (v6/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarButtons_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpSharedQuantitySelect_item"
                }
              ]
            },
            {
              "condition": "isPDPDesktopAggregationVariant",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespDetailTabs_item"
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSharedTitle_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedDesignYourOwnPillLazy_item"
            },
            {
              "condition": "afterDisplay",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EstimatedValue_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PricingGuidanceInfo_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarBlurbs_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpSharedItemFavorites_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSharedPrintDetails_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespMarketplaceNotifications_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarSellerInfoAndContactLazy_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "usePdpEstimateSimilarSoldTest_item"
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSharedBreadcrumbs_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespIconBubblesWrapper_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSharedHeroCarousel_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarItemsLanding_item"
            },
            {
              "condition": "isMultiSku",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSwatchSelector_item"
                }
              ]
            },
            {
              "condition": "isPDPDesktopAggregationVariant",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarDetails_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespMarketplaceStickyHeader_item"
                }
              ]
            },
            {
              "condition": "isEstimateSimilarSoldVariant",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "condition": "afterDisplay",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpSharedEstimateSimilarSoldRange_item"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "usePdpEstimateSimilarSold_item"
                    }
                  ]
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "usePdpPricingAndSaleVariant_item"
            }
          ],
          "type": "Item",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v1/*: any*/)
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": "hasMerchandizingPermission",
              "args": [
                {
                  "kind": "Literal",
                  "name": "name",
                  "value": "BUYER_FE_MERCH_TOOL"
                }
              ],
              "kind": "ScalarField",
              "name": "hasPermission",
              "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
            },
            {
              "condition": "isPDPDesktopAggregationVariant",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespDetailTabs_user"
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedPromoCode_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespIconBubblesWrapper_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSharedHeroCarousel_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarItemsLanding_user"
            },
            {
              "condition": "isMultiSku",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSwatchSelector_user"
                }
              ]
            },
            {
              "condition": "afterDisplay",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarBlurbs_user"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpSharedItemFavorites_user"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSharedPrintDetails_user"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespMarketplaceNotifications_user"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarSellerInfoAndContactLazy_user"
                }
              ]
            },
            {
              "condition": "afterDisplayOrBuaSsr",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarButtons_user"
                }
              ]
            },
            {
              "condition": "isPDPDesktopAggregationVariant",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarDetails_user"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespMarketplaceStickyHeader_user"
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "skipSponsoredItems",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "guestId",
                  "variableName": "guestId"
                },
                (v3/*: any*/),
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "pageSize",
                  "value": 7
                },
                (v4/*: any*/),
                (v5/*: any*/),
                (v1/*: any*/)
              ],
              "concreteType": "SponsoredItems",
              "kind": "LinkedField",
              "name": "sponsoredItems",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSimilarItemsLanding_sponsoredItems"
                }
              ],
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "alias": "similarLandingItems",
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "similarItemsCount"
        },
        (v3/*: any*/),
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "mlType",
          "variableName": "mlType"
        },
        {
          "kind": "Literal",
          "name": "onlyAuctionItems",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "useML",
          "value": true
        }
      ],
      "concreteType": "moreLikeThisItemConnection",
      "kind": "LinkedField",
      "name": "moreLikeThisItem",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSimilarItemsLanding_similarItems"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "476dbb3d7d05d75e32bbacfdac2b6861";

export default node;
